module.exports = __webpack_public_path__ + "img/spectrum-icons-color.a6f9976b.svg";